import React, { useState } from "react";
import axios from "axios";
import { Button, TextField, MenuItem, Paper, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import usePlayerData from "../../hooks/usePlayerData";
import { toast } from "react-toastify";
import GAMECATEGORY from "../register_page/game_category"; // Re-use shared game categories list

function RankingFilter() {
  const { setData } = usePlayerData();

  const [gameEvent, setGameEvent] = useState("");
  const [name, setName] = useState("");
  const [point, setPoint] = useState("");
  const [topList, setTopList] = useState(20);

  // const API_URL = "http://localhost:8006/api/admin/getPlayers";
  const API_URL = "https://badmintonnepal.org/api/admin/getPlayers";

  // Unified API Fetch Function
  const fetchFilteredData = async (queryParams) => {
    try {
      const response = await axios.get(API_URL, {
        params: queryParams,
        withCredentials: true,
      });
      setData(response.data);
    } catch (err) {
      console.error(err);
      toast.error("Unable to fetch rankings");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    const params = {};
    if (gameEvent) params.game_event = gameEvent; // Matches DB column name
    if (name.trim()) params.name = name.trim();
    if (point) params.sort = point;
    if (topList) params.limit = topList;

    fetchFilteredData(params);
  };

  const handleReset = () => {
    setGameEvent("");
    setName("");
    setPoint("");
    setTopList(20);

    // Re-fetch default unfiltered list
    fetchFilteredData({ limit: 20 });
  };

  return (
    <Paper
      elevation={0}
      component="form"
      onSubmit={handleSearch}
      sx={{
        p: 1.5,
        mb: 3,
        borderRadius: 2,
        // border: "1px solid #f0eaef",
        backgroundColor: "#ffffff50",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        alignItems={{ xs: "stretch", sm: "center" }}
        flexWrap="wrap"
      >
        {/* Game Category / Event */}
        <TextField
          select
          size="small"
          label="Game Category"
          value={gameEvent}
          onChange={(e) => setGameEvent(e.target.value)}
          sx={{ minWidth: 160, flex: 1 }}
        >
          <MenuItem value="">All Categories</MenuItem>
          {GAMECATEGORY.map((cat, idx) => (
            <MenuItem key={idx} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </TextField>

        {/* Player Name */}
        <TextField
          size="small"
          label="Player Name"
          placeholder="Search name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ minWidth: 150, flex: 1 }}
        />

        {/* Sort Points */}
        <TextField
          select
          size="small"
          label="Points Sort"
          value={point}
          onChange={(e) => setPoint(e.target.value)}
          sx={{ minWidth: 130, flex: 1 }}
        >
          <MenuItem value="">High to Low (Default)</MenuItem>
          <MenuItem value="point_asc">Low to High</MenuItem>
        </TextField>

        {/* Limit - Note "ALL" in uppercase */}
        <TextField
          select
          size="small"
          label="Top List"
          value={topList}
          onChange={(e) => setTopList(e.target.value)}
          sx={{ minWidth: 100, flex: 1 }}
        >
          <MenuItem value={10}>Top 10</MenuItem>
          <MenuItem value={20}>Top 20</MenuItem>
          <MenuItem value={30}>Top 30</MenuItem>
          <MenuItem value={50}>Top 50</MenuItem>
          <MenuItem value="ALL">All</MenuItem>
        </TextField>

        {/* Action Buttons */}
        <Stack direction="row" spacing={1} sx={{ minWidth: "fit-content" }}>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            startIcon={<SearchIcon fontSize="small" />}
            sx={{
              height: 40,
              px: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Search
          </Button>

          <Button
            type="button"
            variant="outlined"
            onClick={handleReset}
            color="inherit"
            sx={{
              height: 40,
              px: 1.5,
              minWidth: "auto",
            }}
          >
            <RestartAltIcon fontSize="small" />
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default RankingFilter;